
import { AppFilter } from "app/models/app-filter.model";
import { Tenant } from "app/pages/full-pages/admin/tenant/tenant.model";
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbTenant extends AppService {
  abstract getAllTenants(filter: AppFilter): Observable<any>;
  abstract getAllContas(filter: AppFilter): Observable<any>;
  abstract getTenantById(id: number): Observable<any>;
  abstract salvar(tenant: Tenant): Observable<any>;
  abstract salvarEndereco(id: number, endereco: any): Observable<any>;
  abstract salvarTenantStorage(tenant: Tenant);
  abstract salvarNomeTenantStorage(tenant: string);
  abstract getNomeTenantStorage(): Tenant;
  abstract limparTenantStorage();
  abstract salvarTenantSchemaStorage(schema: string);
  abstract getTenantSchemaStorage(): string;
  abstract limparTenantSchemaStorage();
  abstract getTenantStorage(): Tenant;
  abstract desativar(id: number, senha: string): Observable<any>;
  abstract getOnlyNumberIdenfiersTenant(): string;
  abstract getAllTenantsIntegrador(): Observable<any>;
  abstract getTenantsSearch(searchString): Observable<any>;
  abstract getTenantsPreCadastroSearch(codigoPreCadastro: string): Observable<any>;
  abstract getTenantByIdPublic(id): Observable<any>;
  abstract validarConfigNotificacao(): Observable<any>;
  abstract getAllTenantsAtivosPorNome(filter: AppFilter);
  abstract getAllContasAtivasPeloNome(filter: AppFilter);
  abstract updateVoipApp(tenant: Tenant): Observable<any>;
  abstract concederPermissao(tenant: Tenant);
  abstract isSituatorNovaApiHabilitado();
  abstract salvarSituatorZonasHabilitados(habilitarSituatorZona);
  abstract salvarSituatorZonasHabilitados(habilitarSituatorZona);
  abstract getTenantConta();
}
